export default class DynamoModel {
    dbObject = { };
    simpleObject = { };

    getN = item => ((item && item.N) ? item.N : "");
    getS = item => ((item && item.S) ? item.S : "");
    getB = item => ((item && item.B) ? item.B : "");

    // Array
    getSList = item => (item && item.L) ? item.L.map(item => item.S) : [];

    setN = column => { this.dbObject[column] = { N: String(this.simpleObject[column]) }; }
    setS = column => { this.dbObject[column] = (this.simpleObject[column] && this.simpleObject[column].length > 0) ? { S: this.simpleObject[column] } : null; } 
    setB = column => { this.dbObject[column] = { B: this.simpleObject[column] }; }

    // Array
    setSList = column => {
        this.dbObject[column] = { L: ((this.simpleObject[column] && this.simpleObject[column].length>0)
        ? this.simpleObject[column].map(item => { return { S: item }})
        : []) };
    }

}
